// extracted by mini-css-extract-plugin
export var bottom = "bottom__sdR7";
export var description = "description__nqKP";
export var divider = "divider__JlHF";
export var errorMessageLayout = "errorMessageLayout__SUt5";
export var errorPage = "errorPage__VOWO";
export var heading = "heading__TBmP";
export var iconContainer = "iconContainer__XqvZ";
export var messageContainer = "messageContainer__rVEX";
export var plainText = "plainText__VUf9";
export var subtitle = "subtitle__UOKB";
export var title = "title__lrbu";